import type { CompaniesUsersItem } from "../../../../users/userTypes"

import type { WorkgroupMember, WorkgroupMemberRow } from "./workgroupsTypes"

export const toWorkgroupMemberRow = (member: WorkgroupMember, user?: CompaniesUsersItem): WorkgroupMemberRow => ({
    id: member.id,
    displayName: user?.displayName ?? member.displayName,
    email: user?.email,
    department: user?.department,
    employeeId: user?.employeeId,
    roles: user?.roles,
    company: user?.company,
    lastLoginEvent: user?.lastLoginEvent,
    isActive: user?.isActive ?? true,
})
